import type { RewriteResponse, Template, Audience, Tone, Channel } from '../types';
import { VariantCard } from './VariantCard';

interface OutputPanelProps {
  response: RewriteResponse;
  template: Template;
  audience: Audience;
  tone: Tone;
  channel: Channel;
  onReset: () => void;
}

const templateLabels: Record<Template, string> = {
  status_update: 'Status update',
  risk_escalation: 'Risk / escalation',
  metrics_translation: 'Metrics translation',
  executive_summary: 'Executive summary',
};

export function OutputPanel({
  response,
  template,
  audience,
  tone,
  channel,
  onReset,
}: OutputPanelProps) {
  return (
    <div style={{ marginTop: '32px' }}>
      {/* Context bar */}
      <div style={{
        background: 'var(--bg-card)',
        border: '1px solid var(--border)',
        borderRadius: '10px',
        padding: '10px 16px',
        display: 'flex',
        gap: '16px',
        flexWrap: 'wrap',
        marginBottom: '16px',
        fontSize: '12px',
        color: 'var(--text-muted)',
      }}>
        {[
          ['Template', templateLabels[template]],
          ['Audience', audience],
          ['Tone', tone],
          ['Channel', channel],
        ].map(([k, v]) => (
          <span key={k}>
            <strong style={{ color: 'var(--text-secondary)', fontWeight: 500 }}>{k}:</strong>
            {' '}<span style={{ textTransform: 'capitalize' }}>{v}</span>
          </span>
        ))}
      </div>

      {/* Variant cards */}
      <style>{`
        .variant-grid {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
          margin-bottom: 20px;
        }
        @media (max-width: 700px) {
          .variant-grid { grid-template-columns: 1fr; }
        }
      `}</style>
      <div className="variant-grid">
        <VariantCard
          label="Concise"
          subtitle="Tight · scannable · executive-ready"
          content={response.concise} />
        <VariantCard
          label="Detailed"
          subtitle="Structured · comprehensive · formal"
          content={response.detailed} />
      </div>

      {/* Navigation */}
      <div style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingTop: '8px',
      }}>
        <button onClick={onReset} style={{
          fontSize: '14px',
          color: 'var(--accent)',
          background: 'none',
          border: 'none',
          cursor: 'pointer',
          fontWeight: 500,
        }}>
          ← Edit input
        </button>
        <button onClick={onReset} style={{
          padding: '10px 24px',
          borderRadius: '10px',
          border: 'none',
          background: 'var(--accent)',
          color: 'var(--btn-primary-text)',
          fontSize: '14px',
          fontWeight: 600,
          fontFamily: "'Outfit', sans-serif",
          cursor: 'pointer',
          boxShadow: '0 4px 15px rgba(0,212,255,0.25)',
        }}>
          New rewrite
        </button>
      </div>
    </div>
  );
}
